import {DefaultTheme} from 'styled-components'

const normalizeBreakpointsArray = (arr: unknown[], theme: DefaultTheme): unknown[] => {
  const lengthDiff = theme.viewportsArray.length - arr.length
  if (lengthDiff > 0) {
    for (let i = 0; i < lengthDiff; i++) {
      arr.push(arr[arr.length - 1])
    }
  }

  return arr.slice(0, theme.viewportsArray.length)
}

export default normalizeBreakpointsArray
